import axios from 'axios';

export const setAcknowledgeFirstTimeChatAccess = userId => {
    return axios.post(`/api/profile/acknowledgeHasAccessedChatOnce?user_id=${userId}`);
};

export const setAcknowledgeFirstTimeCalendarAccess = userId => {
    return axios.post(`/api/profile/acknowledgeHasAccessedCalendarOnce?user_id=${userId}`);
};
